export default {
  navigationBarTitleText: '更火产品用户协议'
}
